import { Link, Navigate, Outlet } from "react-router-dom";
import { Loader2, ShieldX } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nContext";
import { ControlLayout } from "./ControlLayout";

function FullLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-purple">
      <Loader2 className="h-8 w-8 animate-spin text-brand-magenta-light" aria-label="Wird geladen" />
    </div>
  );
}

export default function ProtectedRoute() {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <ControlLayout>
      <Outlet />
    </ControlLayout>
  );
}

export function Guard({ menuKey, perm, list, children }) {
  const { user } = useAuth();
  const { t } = useI18n();
  const all = user?.permissions?.includes("*");
  // C120: menu-restricted accounts cannot open area lists outside their limited menu by URL.
  const allowed = (all || user?.allowed_menu?.includes(menuKey))
    && (!perm || all || user?.permissions?.includes(perm))
    && !(list && user?.nav_menu && !user.nav_menu.includes(menuKey));
  if (!allowed) {
    return (
      <div role="alert" data-testid="no-access-state" className="flex flex-col items-center justify-center rounded-2xl border border-border bg-white p-12 text-center">
        <ShieldX className="mb-4 h-12 w-12 text-red-500" aria-hidden="true" />
        <h1 className="text-xl font-bold text-brand-purple">{t("noaccess.title")}</h1>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">{t("noaccess.body")}</p>
        <Link to="/" data-testid="no-access-back" className="mt-5 rounded-lg border border-brand-purple/30 px-4 py-2 text-sm font-semibold text-brand-purple hover:bg-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-magenta">Zur Übersicht</Link>
      </div>
    );
  }
  return children;
}
